import React from "react";

// Eliminada la interfaz ButtonProps

const Button = ({ label, onClick, className = "", disabled = false }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`
                flex flex-col items-center justify-center
                text-center
                rounded-lg
                text-white
                hover:bg-blue-200
                transition-all duration-200
                shadow-md hover:shadow-lg
                disabled:bg-gray-400 disabled:cursor-not-allowed
                hover:bg-[rgba(09,127,159,0.2)]
            ${className}
        `}>
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 100 120">
                <rect x="10" y="10" width="80" height="100" rx="8" ry="8" fill="#ffffff" stroke="#217346" strokeWidth="3" />
                <rect x="10" y="10" width="80" height="20" rx="4" ry="4" fill="#217346" />
                <text x="50" y="25" fontFamily="Arial, sans-serif" fontSize="12" fill="#ffffff" textAnchor="middle">XLS</text>
                <rect x="20" y="40" width="30" height="30" fill="#217346" rx="4" ry="4" />
                <text x="35" y="60" fontFamily="Arial, sans-serif" fontSize="18" fill="#ffffff" textAnchor="middle">X</text>
                <line x1="60" y1="50" x2="80" y2="50" stroke="#217346" strokeWidth="2" />
                <line x1="60" y1="65" x2="80" y2="65" stroke="#217346" strokeWidth="2" />
                <line x1="60" y1="80" x2="80" y2="80" stroke="#217346" strokeWidth="2" />
            </svg>
            {/* {label} */}
        </button>
    );
};

export default Button;